import {styled} from '../../styles'

export const SmallLink = styled('a', {
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    color: '#f04e29',
    cursor: 'pointer',
  }
})